<template>
  <div class="search-header">
    <div class="header-box">
      <div class="module-title">
        <div class="content-center items-center" style="display: flex;">
          <img src="@/assets/images/control/vgm.png" style="width: 32px;height:32px;margin-right: 16px">
          <div>{{ moduleTitle }}</div>
        </div>
      </div>
      <div class="header-right">
        <div class="balance-box">
          <span>当前余额：</span>
          <span class="balance-num">{{ account }}</span>
          <span>U币</span>
        </div>
        <div class="oper-box">
          <div class="oper-item oper-primary font-500 pl-40" @click="toTopUp">立即充值</div>
          <div class="oper-item oper-primary">
            <el-dropdown trigger="hover">
              <i class="iconfont icon-a-fuwuxieyifanwei" style="font-size:25px"></i>
              <el-dropdown-menu slot="dropdown" class="oper-menu-box">
                <el-dropdown-item @click.native="getServiceAgreement">服务协议
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="oper-item">
            <i :class="searchShow ? 'iconfont icon-shouqi-shang' : 'iconfont icon-shouqi-xia' " @click="switchSearch" onselectstart="return false"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="searchShow">
      <slot name="searchBox"></slot>
    </div>
    <ServiceAgreement v-if="serviceVisible" :visible.sync="serviceVisible" @closeDialog="closeDialog" />

  </div>
</template>

<script>
import {getAccount} from "@/api/vgmBase";
import ServiceAgreement from './ServiceAgreementTwo'

export default {
  name: "Header",
  components: {
    ServiceAgreement,
  },
  props: {
    moduleTitle: String
  },
  data () {
    return {
      account: 0,
      searchShow: true,
      serviceVisible: false,
      serviceScopeData:'',
    }
  },
  created () {
    if (this.$store.getters.userData && this.$store.getters.userData.companyStatus == 20) {
      this.getAccount()
    }
  },
  methods: {
    // 打开服务协议
    getServiceAgreement () {
      this.serviceVisible = true
    },
    closeDialog () {
      this.serviceVisible = false
      this.serviceScopeVisible = false
    },
    // // 获取金额
    async getAccount () {
      let res = await getAccount()
      this.account = res.data.amount
    },
    // 充值
    toTopUp () {
      // window.location.href = '/user/finance/balance'
      this.$router.push({
        name:"balance",
      })
    },
    //收缩搜索条件
    switchSearch () {
      this.searchShow = !this.searchShow;
    }
  }
};
</script>

<style scoped lang="less">
.search-header {
  font-size: 14px;
  color: #333333;
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 16px;
  .icon-page {
    width: 32px;
    height: 32px;
    background-image: url("../assets/images/icon-page.png");
    background-size: 100% 100%;
    margin: 16px 16px 0 0;
  }
  .pl-40 {
    padding-left: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }
  .header-box {
    height: 60px;
    line-height: 60px;
    padding-left: 24px;
    background: #ffffff;
    border-radius: 4px;
    div {
      display: inline-block;
    }
    .module-title {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
    .header-right {
      float: right;
      display: flex;
      height: 60px;
    }
    .balance-box {
      font-weight: 500;
      display: flex;
      align-items: center;
      .balance-num {
        color: #f58d0b;
        font-size: 20px;
        margin-right: 4px;
        position: relative;
        top: -2px;
      }
    }
    ::v-deep.el-link {
      vertical-align: top;
    }
  }
  .oper-box .icon-a-fuwuxieyifanwei {
    color: #333 !important;
    font-size: 32px !important;
  }

  .icon-a-fuwuxieyifanwei:hover {
    color: #1d73ff !important;
    font-size: 32px !important;
    background: #e7f0fd !important;
    border-radius: 4px;
  }

  .icon-shouqi-shang:hover {
    color: #1d73ff !important;
    background: #e7f0fd !important;
    border-radius: 4px;
  }
  .icon-shouqi-xia:hover {
    color: #1d73ff !important;
    background: #e7f0fd !important;
    border-radius: 4px;
  }

  .icon-shouqi-shang {
    font-size: 32px !important;
    color: #333 !important;
  }
  .icon-shouqi-xia {
    font-size: 32px !important;
    color: #333 !important;
  }
}
</style>
